import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { PATHS } from './paths'

import LoginPage from '../LoginPage'
import MainLoggedPageWrapper from '../MainLoggedPageWrapper'
import NotFoundPage from '../NotFoundPage'

import { AuthenticatedRoute } from '~/auth/components/AuthenticatedRoute'
import { useBrand } from '~/brand'

const InitRoutes: React.FC = () => {
  const { brand } = useBrand()

  return (
    <Switch>
      <Route exact path={`/${PATHS.SIGN_IN}`}>
        <LoginPage />
      </Route>

      <Route exact path="/">
        <Redirect
          to={{
            pathname: `/${PATHS.CUSTOMER}`,
            search: `?brand=${brand}`,
          }}
        />
      </Route>

      <AuthenticatedRoute exact path={`/${PATHS.CUSTOMER}`}>
        <MainLoggedPageWrapper />
      </AuthenticatedRoute>

      <AuthenticatedRoute path={[`/${PATHS.CUSTOMER}/:customerIdentifier`]}>
        <MainLoggedPageWrapper />
      </AuthenticatedRoute>

      <Route component={NotFoundPage} />
    </Switch>
  )
}

export default InitRoutes
